export const Container = ({ children }) => {
	return (
		<main className="dashboard">
			<div className="wrapper">{children}</div>
		</main>
	);
};
